<template>
  <div class="container">
    <h3>Badges</h3>
    <div class="row">
      <div class="col-sm-6 col-md-4" v-for="badge in badges" :key="badge.id">
        <div class="card mb-3">
          <img :src="badge.image" class="card-img-top" alt="...">
          <div class="card-body">
            <h5 class="card-title">{{ badge.title }}</h5>
            <p class="card-text">{{ badge.description }}</p>
          </div>
          <ul class="list-group list-group-flush">
            <li class="list-group-item">
              {{ badge.condition }}
              <span v-if="badge.conditionMet" class="badge badge-success float-right">Completed</span>
              <span v-else class="badge badge-secondary float-right">Incomplete</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  name: 'Badges',
  data () {
    return {
      badges: [
        {
          id: 1,
          title: 'Newbie Hiker',
          image: 'https://via.placeholder.com/300x200?text=Newbie+Hiker',
          condition: 'Complete your first hike',
          conditionMet: false,
          description: 'Congratulations on completing your first hike! Keep exploring and share your adventures with the community.'
        },
        {
          id: 2,
          title: 'Trailblazer',
          image: 'https://via.placeholder.com/300x200?text=Trailblazer',
          condition: 'Complete 10 unique hikes',
          conditionMet: false,
          description: 'You\'ve discovered 10 amazing trails! Keep exploring new paths and inspiring others with your adventures.'
        },
        {
          id: 3,
          title: 'Mountain Goat',
          image: 'https://via.placeholder.com/300x200?text=Mountain+Goat',
          condition: 'Complete a hike with a minimum elevation gain of 2,000 feet (610 meters)',
          conditionMet: false,
          description: 'You\'ve conquered a challenging climb! Your determination and stamina are truly impressive.'
        },
        {
          id: 4,
          title: '100-Mile Club',
          image: 'https://via.placeholder.com/300x200?text=100-Mile+Club',
          condition: 'Accumulate a total hiking distance of 100 miles (160 kilometers)',
          conditionMet: false,
          description: 'You\'ve hiked 100 miles! Your passion for adventure knows no bounds. Keep up the great work!'
        },
        {
          id: 5,
          title: 'High Peaks Explorer',
          image: 'https://via.placeholder.com/300x200?text=High+Peaks+Explorer',
          condition: 'Complete 5 hikes with a minimum elevation gain of 4,000 feet (1,219 meters) each',
          conditionMet: false,
          description: 'You\'ve scaled some serious heights! Your passion for high-altitude adventures is truly inspiring.'
        },
        {
          id: 6,
          title: 'Seasoned Adventurer',
          image: 'https://via.placeholder.com/300x200?text=Seasoned+Adventurer',
          condition: 'Complete a hike in each of the four seasons (Winter,Spring, Summer, Fall)',
          conditionMet: false,
          description: 'You\'ve experienced the beauty of nature in every season. Your dedication to exploring the great outdoors all year round is commendable!'
        },
        {
          id: 7,
          title: 'Trail Angel',
          image: 'https://via.placeholder.com/300x200?text=Trail+Angel',
          condition: 'Leave 10 helpful reviews on different hikes',
          conditionMet: false,
          description: 'Thank you for sharing your knowledge and experience with the community! Your insights help others plan their adventures.'
        },
        {
          id: 8,
          title: 'Weekend Warrior',
          image: 'https://via.placeholder.com/300x200?text=Weekend+Warrior',
          condition: 'Complete 5 hikes within a 30-day period',
          conditionMet: false,
          description: 'You\'ve made the most of your weekends! Your dedication to getting outdoors and staying active is truly motivating.'
        },
        {
          id: 9,
          title: 'Hiking Buddy',
          image: 'https://via.placeholder.com/300x200?text=Hiking+Buddy',
          condition: 'Invite 5 friends to join the community',
          conditionMet: false,
          description: 'You\'re expanding our community and helping others discover the joys of hiking. Thank you for being a true Hiking Buddy!'
        },
        {
          id: 10,
          title: 'Challenge Champion',
          image: 'https://via.placeholder.com/300x200?text=Challenge+Champion',
          condition: 'Complete a seasonal or special event challenge',
          conditionMet: false,
          description: 'Congratulations on conquering the challenge! Your determination and enthusiasm are truly inspiring.'
        }
      ]
    }
  },
  computed: {
    user () {
      return firebase.auth().currentUser
    }
  },
  mounted () {
  }
}
</script>